import { api_configuration } from "../../common";
import api_widget = api_configuration.libraries.gui_definition_lib.types.widget;
import api_modifications = api_configuration.types.modifications;
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import csr = api_configuration.types.client_state.alan_api;
import { client_state } from "./ClientState";
import { createIdPathBuilderFromNode } from "../navigation/createIdPathFromNode";
import { IdPathBuilder } from "../navigation/IdPathBuilder";
import DestructorTree from "../DestructorTree";

export function storeNumber(
	node: csr.Cnode,
	number_property: api_views.Cnumber__type__configuration,
	value: number,
	entry_keys: string[]
): void {
	storeWidgetNumber(
		node,
		number_property.parent.parent.input.gui_widget_configuration_node(),
		number_property.inferences.number(),
		value,
		entry_keys
	);
}
export function storeWidgetNumber(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	number_property: api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node,
	value: number,
	entry_keys: string[]
): void {
	const local_value = initializeNumberValue(node, gui_context, number_property, entry_keys);
	local_value.value = value;
	for (const observer of local_value.observer) {
		observer(value);
	}
	number_property.properties.persistence.properties.persist.switch({
		no: undefined,
		yes: ($) => {
			const storageId = propertyIdentification(
				$.properties.per_entry.switch({
					yes: node,
					no: null,
				}),
				gui_context,
				number_property,
				entry_keys
			);
			$.properties.per_session.switch({
				no: () => {
					window.localStorage.setItem(storageId, value.toString());
				},
				yes: () => {
					session_storage[storageId] = value;
				},
			});
		},
	});
}
export function getNumber(
	node: csr.Cnode,
	number_property: api_views.Cnumber__type__configuration,
	entry_keys: string[]
): ConfigurationValue<number> {
	return getWidgetNumber(
		node,
		number_property.parent.parent.input.gui_widget_configuration_node(),
		number_property.inferences.number(),
		entry_keys
	);
}
export function getWidgetNumber(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	number_property: api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
): ConfigurationValue<number> {
	const local_value = initializeNumberValue(node, gui_context, number_property, entry_keys);
	let number_value = local_value.value;
	if (number_value === undefined) {
		const persist = number_property.properties.persistence.properties.persist;
		switch (persist.state.name) {
			case "no":
				break;
			case "yes": {
				const $ = persist.state.node;
				const storageId = propertyIdentification(
					$.properties.per_entry.switch({
						no: null,
						yes: node,
					}),
					gui_context,
					number_property,
					entry_keys
				);
				switch ($.properties.per_session.state.name) {
					case "no": {
						const string_value = window.localStorage.getItem(storageId);
						number_value = string_value !== null ? Number.parseInt(string_value) : undefined;
						number_value = number_value !== undefined && isNaN(number_value) ? undefined : number_value;
						break;
					}
					case "yes": {
						number_value = session_storage[storageId];
						break;
					}
					default:
						unexpectedState($.properties.per_session.state);
				}
				break;
			}
			default:
				unexpectedState(persist.state);
		}
	}
	return new ConfigurationValue(local_value.observer, number_value);
}
export function registerNumberDestructor(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	number_property: api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node,
	destructor: DestructorTree,
	entry_keys: string[]
): void {
	const persist = number_property.properties.persistence.properties.persist;
	switch (persist.state.name) {
		case "no": {
			destructor.onDestroy(() => {
				deinitializeNumberValue(node, gui_context, number_property, entry_keys);
			});
			break;
		}
		case "yes":
			break;
		default:
			unexpectedState(persist.state);
	}
}

export function storeText(
	node: csr.Cnode,
	text_property: api_views.Ctext__type__configuration,
	value: string,
	entry_keys: string[]
): void {
	storeWidgetText(
		node,
		text_property.parent.parent.input.gui_widget_configuration_node(),
		text_property.inferences.text(),
		value,
		entry_keys
	);
}
export function getText(
	node: csr.Cnode,
	text_property: api_views.Ctext__type__configuration,
	entry_keys: string[]
): ConfigurationValue<string> {
	return getWidgetText(
		node,
		text_property.parent.parent.input.gui_widget_configuration_node(),
		text_property.inferences.text(),
		entry_keys
	);
}
export function storeWidgetText(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	text_property: api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node,
	value: string,
	entry_keys: string[]
): void {
	const local_calue = initializeTextValue(node, gui_context, text_property, entry_keys);
	local_calue.value = value;
	for (const observer of local_calue.observer) {
		observer(value);
	}
	text_property.properties.persistence.properties.persist.switch({
		no: undefined,
		yes: ($) => {
			const storageId = propertyIdentification(
				$.properties.per_entry.switch({
					no: null,
					yes: node,
				}),
				gui_context,
				text_property,
				entry_keys
			);
			$.properties.per_session.switch({
				no: () => {
					window.localStorage.setItem(storageId, value);
				},
				yes: () => {
					session_storage[storageId] = value;
				},
			});
		},
	});
}
export function getWidgetText(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	text_property: api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
): ConfigurationValue<string> {
	const local_value = initializeTextValue(node, gui_context, text_property, entry_keys);
	let text_value = local_value.value;
	if (text_value === undefined) {
		const persist = text_property.properties.persistence.properties.persist;
		switch (persist.state.name) {
			case "no":
				break;
			case "yes": {
				const $ = persist.state.node;
				const storageId = propertyIdentification(
					$.properties.per_entry.switch({
						no: null,
						yes: node,
					}),
					gui_context,
					text_property,
					entry_keys
				);
				switch ($.properties.per_session.state.name) {
					case "no": {
						text_value = window.localStorage.getItem(storageId) || undefined;
						break;
					}
					case "yes": {
						text_value = session_storage[storageId];
						break;
					}
					default:
						unexpectedState($.properties.per_session.state);
				}
				break;
			}
			default:
				unexpectedState(persist.state);
		}
	}
	return new ConfigurationValue(local_value.observer, text_value);
}
export function registerTextDestructor(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	text_property: api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node,
	destructor: DestructorTree,
	entry_keys: string[]
): void {
	const persist = text_property.properties.persistence.properties.persist;
	switch (persist.state.name) {
		case "no": {
			destructor.onDestroy(() => {
				deinitializeTextValue(node, gui_context, text_property, entry_keys);
			});
			break;
		}
		case "yes":
			break;
		default:
			unexpectedState(persist.state);
	}
}
export function setState(
	node: csr.Cnode,
	state_group_property: api_views.Cstate_group__type__configuration,
	selected_state: string,
	configuration: api_modifications.alan_api.Tconfiguration_node,
	entry_keys: string[]
): void {
	setWidgetState(
		node,
		state_group_property.parent.parent.input.gui_widget_configuration_node(),
		state_group_property.inferences.state_group(),
		selected_state,
		configuration,
		entry_keys
	);
}
export function setWidgetState(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	state_group_property: api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
	selected_state: string,
	configuration: api_modifications.alan_api.Tconfiguration_node,
	entry_keys: string[]
): void {
	const widget_configuration = state_group_property.parent.parent.parent;
	const modification = api_modifications.alan_api.Cmodifications.create(
		{
			widget: widgetName(widget_configuration),
			path: createPathToWidgetRoot(widget_configuration, { "has steps": ["no", {}] }),
			"state group": state_group_property.parent.parent.key,
			"selected state": selected_state,
			configuration: configuration,
		},
		{
			widget: client_state.input.widget,
		}
	);

	const local_value = initializeStategroupValue(node, gui_context, state_group_property, entry_keys);
	local_value.value = modification;
	for (const observer of local_value.observer) {
		observer(local_value.value);
	}
	state_group_property.properties.persistence.properties.persist.switch({
		no: undefined,
		yes: ($) => {
			const storageId = propertyIdentification(
				$.properties.per_entry.switch({
					no: null,
					yes: node,
				}),
				gui_context,
				state_group_property,
				entry_keys
			);
			modification.key = storageId;
			storeState(modification);
		},
	});
}
export function storeState(modification: api_modifications.alan_api.Cmodifications): void {
	const state_group_property = modification.properties.state_group.ref;
	const persist_property = state_group_property.properties.persistence.properties.persist;
	switch (persist_property.state.name) {
		case "no":
			break;
		case "yes": {
			const $ = persist_property.state.node;
			const storageId = modification.key!;
			const serialized_configuration = api_modifications.serializer_json.serialize(modification);
			$.properties.per_session.switch({
				no: () => {
					window.localStorage.setItem(storageId, JSON.stringify(serialized_configuration));
				},
				yes: () => {
					session_storage[storageId] = serialized_configuration;
				},
			});
			break;
		}
		default:
			unexpectedState(persist_property.state);
	}
}
export function getState(
	node: csr.Cnode,
	state_group: api_views.Cstate_group__type__configuration,
	entry_keys: string[]
): ConfigurationValue<api_modifications.alan_api.Cmodifications> {
	return getWidgetState(
		node,
		state_group.parent.parent.input.gui_widget_configuration_node(),
		state_group.inferences.state_group(),
		entry_keys
	);
}
export function getWidgetState(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	state_group: api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
): ConfigurationValue<api_modifications.alan_api.Cmodifications> {
	const local_value = initializeStategroupValue(node, gui_context, state_group, entry_keys);
	let modification = local_value.value;
	if (modification === undefined) {
		const persist = state_group.properties.persistence.properties.persist;
		switch (persist.state.name) {
			case "no":
				break;
			case "yes": {
				const $ = persist.state.node;
				const storageId = propertyIdentification(
					$.properties.per_entry.switch({
						no: null,
						yes: node,
					}),
					gui_context,
					state_group,
					entry_keys
				);
				let value: any | null = null;
				switch ($.properties.per_session.state.name) {
					case "no": {
						const string_value = window.localStorage.getItem(storageId);
						if (string_value === null) {
							value = null;
						} else {
							try {
								value = JSON.parse(string_value);
							} catch (e) {
								window.localStorage.removeItem(storageId);
								value = null;
							}
						}
						break;
					}
					case "yes": {
						value = session_storage[storageId] || null;
						break;
					}
					default:
						unexpectedState($.properties.per_session.state);
				}
				if (value !== null) {
					try {
						modification = api_modifications.alan_api.Cmodifications.create(value, {
							widget: client_state.input.widget,
						});
						modification.key = storageId;
					} catch (e) {
						switch ($.properties.per_session.state.name) {
							case "no": {
								window.localStorage.removeItem(storageId);
								break;
							}
							case "yes":
								break;
							default:
								unexpectedState($.properties.per_session.state);
						}
					}
				}
				break;
			}
			default:
				unexpectedState(persist.state);
		}
	}
	return new ConfigurationValue(local_value.observer, modification);
}
export function registerStateDestructor(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	state_group: api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
	destructor: DestructorTree,
	entry_keys: string[]
): void {
	const persist = state_group.properties.persistence.properties.persist;
	switch (persist.state.name) {
		case "no": {
			destructor.onDestroy(() => {
				deinitializeStategroupValue(node, gui_context, state_group, entry_keys);
			});
			break;
		}
		case "yes":
			break;
		default:
			unexpectedState(persist.state);
	}
}
export class ConfigurationValue<T> {
	constructor(private observers: Set<(value: T) => void>, public readonly value: T | undefined) {}
	subscribe(callback: (value: T) => void): { unsubscribe: () => void } {
		this.observers.add(callback);
		return {
			unsubscribe: () => {
				this.observers.delete(callback);
			},
		};
	}
}

type Subscription<P, R> = Map<
	api_views.Cgui_widget_configuration_node,
	Map<
		P,
		Map<
			string,
			{
				observer: Set<(new_value: R) => void>;
				value: R | undefined;
				check_local_storage: boolean;
			}
		>
	>
>;

const session_storage: Record<string, any> = {};
const text_values = new Map<
	csr.Cnode,
	Subscription<api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node, string>
>();
const number_values = new Map<
	csr.Cnode,
	Subscription<api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node, number>
>();
const stategroup_values = new Map<
	csr.Cnode,
	Subscription<
		api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
		api_modifications.alan_api.Cmodifications
	>
>();
function initializeValue<P, R>(
	node: csr.Cnode,
	context: api_views.Cgui_widget_configuration_node,
	property: P,
	entry_keys: string[],
	values: Map<csr.Cnode, Subscription<P, R>>
) {
	let n = values.get(node);
	if (n === undefined) {
		node.onDestroy(() => values.delete(node));
		n = values.set(node, new Map()).get(node)!;
	}
	let pp = n!.get(context);
	if (pp === undefined) {
		pp = n.set(context, new Map()).get(context)!;
	}
	let p = pp!.get(property);
	if (p === undefined) {
		p = pp.set(property, new Map()).get(property)!;
	}
	const entry_string = entry_keys.join(" ");
	let e = p.get(entry_string);
	if (e === undefined) {
		e = p
			.set(entry_string, {
				observer: new Set(),
				value: undefined,
				check_local_storage: true,
			})
			.get(entry_string)!;
	} else {
		e.check_local_storage = false;
	}
	return e;
}
function initializeNumberValue(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return initializeValue(node, gui_context, property, entry_keys, number_values);
}
function initializeTextValue(
	node: csr.Cnode,
	context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return initializeValue(node, context, property, entry_keys, text_values);
}
function initializeStategroupValue(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return initializeValue(node, gui_context, property, entry_keys, stategroup_values);
}

function deinitializeValue<P, R>(
	node: csr.Cnode,
	context: api_views.Cgui_widget_configuration_node,
	property: P,
	values: Map<csr.Cnode, Subscription<P, R>>,
	entry_keys: string[]
) {
	const node_values = values.get(node);
	const context_values = node_values?.get(context);
	const property_values = context_values?.get(property);
	property_values?.delete(entry_keys.join(" "));
	if (property_values?.size === 0) {
		context_values?.delete(property);
	}
	if (context_values?.size === 0) {
		node_values?.delete(context);
	}
	if (node_values?.size === 0) {
		values.delete(node);
	}
}
function deinitializeNumberValue(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Cnumber__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return deinitializeValue(node, gui_context, property, number_values, entry_keys);
}
function deinitializeTextValue(
	node: csr.Cnode,
	context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Ctext__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return deinitializeValue(node, context, property, text_values, entry_keys);
}
function deinitializeStategroupValue(
	node: csr.Cnode,
	gui_context: api_views.Cgui_widget_configuration_node,
	property: api_widget.alan_api.Cstate_group__type__configuration__type__attributes__widget_configuration_node,
	entry_keys: string[]
) {
	return deinitializeValue(node, gui_context, property, stategroup_values, entry_keys);
}

function propertyIdentification(
	node: csr.Cnode | null,
	parent_context: api_views.Cgui_widget_configuration_node,
	property: { parent: api_widget.alan_api.Cconfiguration__type__attributes__widget_configuration_node; path: string },
	entry_keys: string[]
) {
	const view_id = parent_context.root.key;
	const entry_id = node === null ? "" : IdPathBuilder.serialize(createIdPathBuilderFromNode(node));
	const parent_path = parent_context?.path ?? "";
	const property_path = property.path;
	const serialized_entry_keys = entry_keys.filter(dont_equal_entries).join(",");
	return `${view_id}-${entry_id}-${parent_path}-${property_path}-${serialized_entry_keys}`;
}
function widgetName(configuration: api_widget.alan_api.Cwidget_configuration_node): string {
	return configuration.input.location().switch({
		widget: ($) => $.key as string,
		binding: ($) => widgetName($.parent.parent),
		"configuration list": ($) => widgetName($.parent.parent.parent),
		"configuration state": ($) => widgetName($.parent.parent.parent.parent),
		window: ($) => widgetName($.parent.parent),
	});
}
function createPathToWidgetRoot(
	configuration: api_widget.alan_api.Cwidget_configuration_node,
	tail: api_modifications.alan_api.Twidget_configuration_path
): api_modifications.alan_api.Twidget_configuration_path {
	return configuration.input.location().switch<api_modifications.alan_api.Twidget_configuration_path>({
		widget: () => tail,
		binding: ($) =>
			createPathToWidgetRoot($.parent.parent, {
				"has steps": [
					"yes",
					{
						attribute: $.parent.key,
						type: ["binding", {}],
						tail: tail,
					},
				],
			}),
		"configuration list": ($) =>
			createPathToWidgetRoot($.parent.parent.parent, {
				"has steps": [
					"yes",
					{
						attribute: $.parent.parent.key,
						type: [
							"configuration",
							{
								type: ["list", {}],
							},
						],
						tail: tail,
					},
				],
			}),
		"configuration state": ($) =>
			createPathToWidgetRoot($.parent.parent.parent.parent, {
				"has steps": [
					"yes",
					{
						attribute: $.parent.parent.parent.key,
						type: [
							"configuration",
							{
								type: [
									"state",
									{
										state: $.key,
									},
								],
							},
						],
						tail: tail,
					},
				],
			}),
		window: ($) =>
			createPathToWidgetRoot($.parent.parent, {
				"has steps": [
					"yes",
					{
						attribute: $.parent.key,
						type: ["window", {}],
						tail: tail,
					},
				],
			}),
	});
}
function dont_equal_entries(key: string): boolean {
	//Do not equal entries, because this changes over time.
	return !key.startsWith("entries:");
}
